<template>
    <div class="shopping-cart" >
        <img class="my-order h-6 w-6" src="@/assets/icon/header/ic-order-list.svg"
            @click="gotoCart('/myorder')"
        />
        <img class="h-6 w-6" src="@/assets/icon/header/ic-shopping-cart.svg" @click="gotoCart()"/>
        <span v-if="count > 0" class="badge">{{$store.state.count.count}}</span>
    </div>
</template>

<script>
import AccountMixin from '@/mixin/AccountMixin';
import BzbsCart from '@/core/Cart/service/BzbsCart';

export default {
    name: 'ShoppingCart',
    mixins:[AccountMixin],
    mounted () {

    },
    computed: {
        count() {
            return this.$store.getters.getCount
        }
    },
    methods: {
        accountInitiated: function() {
            if (this.isLogin) {
                this.getCartCount();
            }
        },
        gotoCart(path) {
            this.$emit('gotoCart', path)
        },
        getCartCount: async function() {
            return new Promise((resolve) => {
                BzbsCart.apiGetCartCount(this.getToken()).subscribe((res) => {
                    this.$store.commit('increment', res.cart_count)
                    resolve(true);
                }, (error) => {
                    console.log(error)
                })
            })
        }
    },
}
</script>

<style scoped>
@import "../../../../style/base/base.scss";
@import "./ShoppingCart.scss";
</style>
